import MapHelper from "@Scripts/Infrastructure/MapHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class ArchiveImageListPage extends BasePage {
    public static async init() {
        await super.init();

        if ((<any>window).App.bag.Images.length > 0) {
            MapHelper.init();
        }

        this.setTab();
        this.setMap();
    }

    private static setTab() {
        let tabs = document.querySelectorAll(".tab .item"),
            archiveItems = document.querySelectorAll(".archive-item");

        if (tabs && tabs.length !== 0) {
            for (let i = 0; i < tabs.length; i++) {
                tabs[i].addEventListener("click", function () {
                    let section = tabs[i].getAttribute("data-type"),
                        selectedArchiveItem = document.querySelectorAll(".archive-item[data-type=" + section + "]"),
                        selectedTab = document.querySelectorAll(".tab .item[data-type=" + section + "]");

                    tabs.forEach(function (tab) {
                        if (tab.classList.contains("selected")) {
                            tab.classList.remove("selected");
                        }
                    });

                    archiveItems.forEach(function (archiveItem) {
                        if (archiveItem.classList.contains("show")) {
                            archiveItem.classList.remove("show");
                        }
                    });

                    selectedArchiveItem[0].classList.add("show");
                    selectedTab[0].classList.add("selected");

                })
            }
        }
    }

    private static setMap() {
        let images = (<any>window).App.bag.Images;
        let markers = [];

        images.forEach(function (image) {
            if (image.latitude && image.longitude) {
                var popupContent = "<a href=\"/it/archivio-fotografico/" + image.code + "\"  class=\"link\"><img src=\"/it/media/archivio-fotografico/images/250-187-Fix/" + image.file.code + "\" /><span><div class=\"title\">" + image.title + "</div></span></a>";

                let marker = MapHelper.setMarker(image.latitude, image.longitude, popupContent);

                if (marker) {
                    markers.push(marker);
                }
            }
        });

        MapHelper.setBounds(markers);
    }
}